// extracted by mini-css-extract-plugin
export default {"inputWrapper":"pSb7lz","input":"Q_F4js"};